// Top-level pages show no one's data: logs are only visible to the owner (/me) or via a share link.
export default function WelcomePage() {
  return (
    <div className="landing pt-safe pb-safe min-h-dvh overflow-hidden text-white">
      <div className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center gap-6 px-4 text-center">
        <h1 className="font-display text-5xl drop-shadow-[3px_3px_0_rgba(0,0,0,0.35)] md:text-7xl">Macro Mate</h1>
        <p className="text-white/80">
          Ghi bữa ăn bằng ảnh hoặc vài dòng mô tả, AI ước tính calo và đạm, rồi chia sẻ nhật ký với PT bằng một đường link.
        </p>
        <div className="flex flex-col gap-2">
          {/* One page for both: signing in with a provider creates the account the first time. */}
          <a href="/login" className="btn btn-primary">Bắt đầu</a>
        </div>
        <p className="text-sm text-white/60">Được gửi link xem nhật ký? Mở đúng đường link đó để xem.</p>
      </div>
    </div>
  );
}
